import { render } from "./flows.vue?vue&type=template&id=e0f0b2ee"
import script from "./flows.vue?vue&type=script&lang=js"
export * from "./flows.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__